module.exports = __webpack_public_path__ + "img/changjing-02.4d82fbab.png";